export { TITLE, DESCRIPTION, BUTTON } from './constants'
export type { TCorporateLeadProps } from './types'
export { images, ellipses } from './images'
export { createRenderImgsArr } from './utils'
